import {
  TextTemplatePlaceholderDTO,
  TextTemplatePlaceholderPropertyDTO,
} from 'src/dtos/TextTemplatePlaceholdersDTO';
import { EnTextTemplatePlaceholderPropertyType } from 'src/enums/EnTextTemplatePlaceholderPropertyType';

export class TextTemplatePlaceholder {
  public name!: string;
  public properties!: TextTemplatePlaceholderProperty[];

  constructor(dto: TextTemplatePlaceholderDTO) {
    this.name = dto.identifier;
    this.properties = dto.properties.map(
      (property) =>
        new TextTemplatePlaceholderProperty(
          property,
          `${dto.identifier}.${property.name}`
        )
    );
  }
}

export class TextTemplatePlaceholderProperty {
  public identifier!: string;
  public name!: string;
  public type!: EnTextTemplatePlaceholderPropertyType;
  public isArray!: boolean;
  public properties?: TextTemplatePlaceholderProperty[];
  public enumValues?: TextTemplatePlaceholderPropertyEnumValue[];

  constructor(dto: TextTemplatePlaceholderPropertyDTO, identifier: string) {
    this.identifier = identifier;

    this.name = dto.name;
    this.type = dto.type;
    this.isArray = dto.isArray;

    if (dto.objectDefinition) {
      this.properties = dto.objectDefinition.properties.map(
        (property) =>
          new TextTemplatePlaceholderProperty(
            property,
            `${identifier}.${property.name}`
          )
      );
    }

    this.enumValues = dto.enumValues;
  }
}

export class TextTemplatePlaceholderPropertyEnumValue {
  [key: number]: string;
}
